import React, { Fragment, useEffect, useState } from 'react';
import { Layout, Menu } from '@cloud/atom-ui';
import useMappedState from '@src/utils/useMappedState';
import { i18n, locale } from '@src/utils/i18n';
import { useDispatch } from "redux-react-hook";
import * as nls from './nls';
import './style.m.css';
import Headers from './headers';
import Customer from './customer';
import * as actions from '../../actions';
import { doGet } from '@src/utils/toolkit'
import constant from '@src/utils/constant';
import { isHuaweiCloud, isICSLHuaweiCloud } from "@src/utils/common";
import webConfig from '@src/configs/web.config';
import { WEGO_TEN_LIST, ROBOT_TEN_LIST } from './constants';
import BottomFooter from '@src/components/BottomFooter';

const { SubMenu } = Menu;
const { Header, Content, Sider } = Layout;
const I18N = i18n(nls);

export default props => {

  const { user, siteType, tenant: tenantInfo } = useMappedState('root');
  // 是否为生产环境
  const isProduction = isHuaweiCloud();
  // 是否为icsl环境
  const isICSL = isICSLHuaweiCloud();
  const {
    root: { licenseBrands },
  } = useMappedState();
  const dispatch = useDispatch()
  let seISV = sessionStorage.getItem('ISVVALUE')

  // 判断是否购买appcube,跳转不同路径
  const [isPurchase, setIsPurchase] = useState(null);

  // 接口数据 应用魔方请求
  const applyCube = () => {
    const url = `/${process.env.REACT_APP_API_CONTEXT}/service/system/common/initMycData`;
    doGet(url, (res) => {
      setIsPurchase(res.isBuyAppCube)
      if (res.isBuyAppCube) {
        setIsPurchase(true)
      } else {
        setIsPurchase(false)
      }
    }
    )
  }

  const getPath = url => {
    let hash;
    return ((hash = /#([^?]*)?\??/.exec(url)) && hash[1]) || '';
  };
  const RenderMenu = (menu) => {
    /* 如果当前是详情页面的编辑
      （1） 直接点击左侧的导航页面的路由不切换保持原本的路由
        （1.1 点击确定的时候在更改到相对应的路由
          1.2 点击取消页面保持原本的路由
         ）
      （2） 点击返回按钮
        （2.1 点击确定的时候在更改到相对应的路由
          2.2 点击取消页面保持原本的路由
         ）
    */
    let href;
    if (window.location.href.indexOf('baseInfo') !== -1 && window.location.href.indexOf('edit') !== -1) {
      let indexNum = window.location.href.indexOf('#');
      let newUrl = window.location.href.substring(indexNum)
      href = newUrl;
    } else {
      href = menu.resUrl;
    }
    if (!menu.isShow) return null;
    if (menu.subResList && menu.subResList.length) {
      // 追加 “0” 防止与子菜单 key 冲突
      return (
        <SubMenu key={menu.key} title={<span>{menu.menuName}</span>}>
          {menu.subResList.map((menu, index) => {
            return RenderMenu(menu, index);
          })}
        </SubMenu>
      );
    }
    return (
      <Menu.Item key={menu.key}>
        <a href={href} target={menu.open ? '_blank' : '_self'} style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}
          onClick={() => {
            handleDelveFlag(menu.resUrl)
          }}>
          {menu.menuName}
        </a>
      </Menu.Item>
    );
  };
  //  传递是否是在编辑页时点击左侧路由
  const handleDelveFlag = (href) => {
    dispatch(actions.searchFlag(false))
    if (window.location.href.indexOf('baseInfo') !== -1 && window.location.href.indexOf('edit') !== -1) {
      dispatch(actions.changeRouter(href))
      dispatch(actions.routeFlag(true))
    }
  }
  const getSearchString = (key, Url) => {
    let str = Url;
    if (str.indexOf('?') > 0) {
      str = str.split("?")[1];
    } else {
      return null
    }
    // 获取URL中?之后的字符（去掉第一位的问号）
    // 以&分隔字符串，获得类似name=xiaoli这样的元素数组
    let arr = str.split("&");
    let obj = new Object();
    // 将每一个数组元素以=分隔并赋给obj对象
    for (let i = 0; i < arr.length; i++) {
      let tmp_arr = arr[i].split("=");
      obj[decodeURIComponent(tmp_arr[0])] = decodeURIComponent(tmp_arr[1]);
    }
    return obj[key];
  };
  const appCubeUrl = window?.location?.hostname.includes('uat') ? constant.CLOUDUAT_URL : constant.OPEN_URL;
  let subMenu;
  let defaultOpenKeys;
  subMenu = [
    {//首页
      menuName: I18N['guidePage'],
      key: 'guide',
      resUrl: '#/wecode/guide/guide',
      isShow: siteType && siteType.site_type != 2 ? true : false
    },
    {//企业内部应用
      menuName: I18N['enterpriseInternalApp'],
      key: 'wecode',
      subResList: [
        {//we码
          menuName: I18N['weCode'],
          resUrl: '#/1/wecode',
          key: '1',
          isShow: true
        },
        {//轻应用
          menuName: I18N['liteApp'],
          resUrl: '#/2/wecode',
          key: '2',
          isShow: true
        },
        {//无界面应用
          menuName: I18N['nointerface'],
          resUrl: '#/5/wecode',
          key: '5',
          isShow: true
        },
        {// 机器人
          menuName: I18N['robot'],
          resUrl: '#/wecode/robot/list',
          key: 'robot',
          isShow: !(isProduction || isICSL) || ROBOT_TEN_LIST?.includes(tenantInfo?.tenantId) // 非生产和icsl环境展示，生产或icsl仅华技租户展示
        }
      ],
      isShow: true
    },
    {//第三方企业应用
      menuName: I18N['thirdPartyApp'],
      key: 'liteapp',
      subResList: [
        {//we码
          menuName: I18N['weCode'],
          resUrl: '#/3/wecode',
          key: '3',
          isShow: true
        },
        {//轻应用
          menuName: I18N['liteApp'],
          resUrl: '#/4/wecode',
          key: '4',
          isShow: true
        },
      ],
      isShow: siteType && siteType.site_type != 2 ? true : false
    },
    {//开发工具
      menuName: I18N['developTools'],
      key: 'developTools',
      subResList: [
        {//WeMax
          menuName: I18N['wemax'],
          key: 'wemax',
          resUrl: webConfig.wemax,
          isShow: true,
          open: true
        },
        {//应用魔方
          menuName: I18N['applyCube'],
          key: 'applyCube',
          resUrl: isPurchase ? appCubeUrl : constant.NOT_PURCHASED,
          isShow: true,
          open: true
        },
        {//WeGo
          menuName: I18N['weGo'],
          key: 'weGo',
          resUrl: `${webConfig.openPlatformHome.weGo}?tenantId=${tenantInfo?.tenantId}`,
          isShow: WEGO_TEN_LIST?.includes(tenantInfo?.tenantId),
          open: true
        },
        {//We码雷达
          menuName: I18N['wecodeRadar'],
          key: 'wecodeRadar',
          resUrl: process.env?.REACT_APP_RADAR,
          isShow: true,
          open: true
        },
      ],
      isShow: true
    },
    {//连接器
      menuName: '连接器',
      key: 'connectors',
      subResList: [
        {//连接器
          menuName: '连接器',
          key: 'connectors',
          resUrl: '#/wecode/myconnectors',
          isShow: true,
        },
        {//连接流
          menuName: '连接流',
          key: 'connectionflow',
          resUrl: '#/wecode/connectionflow',
          isShow: true,
        },
        {//用量统计
          menuName: '用量统计',
          key: 'connectorFlowMonitoring',
          resUrl: '#/wecode/connectorFlowMonitoring',
          isShow: true,
        },
        {//连接流执行记录
          menuName: '连接流执行记录',
          key: 'connectorFlowExecution',
          resUrl: `#/wecode/connectorFlowExecution`,
          isShow: true,
        },
      ],
      isShow: true,
    },


    {//ROMA 插件
      menuName: I18N['roma'],
      key: 'roma',
      resUrl: '#/wecode/roma/romaList',
      isShow: siteType && siteType.site_type != 2 ? (sessionStorage.getItem('canSeeRoma') ? sessionStorage.getItem('canSeeRoma') : user && user.canSeeRoma) : null
    },
    {//应用推广
      menuName: I18N['popularize'],
      key: 'popularize',
      resUrl: '#/wecode/popularize/popularizeList',
      isShow: siteType && siteType.site_type != 2 && seISV == 1 ? true : false
    },
  ];
  defaultOpenKeys = ['wecode', 'liteapp', 'developTools', 'connectors'];
  const { children, layout } = props;
  let selectedKey = '';
  let type = props.match.params.type
  selectedKey = type;
  // 地址栏 layout 优先
  let _layout;
  try {
    _layout = props.history.queryParams.query.layout;
  } catch (e) {
  }
  _layout = _layout || layout;

  useEffect(() => {
    applyCube();
  }, []);

  const layouts = {
    outer: (
      <Layout style={{ minHeight: '100%' }}>
        <Header className="header">
          <Headers />
        </Header>
        <Content style={{ background: '#FFFFFF', border: '1px solid #DBE6F1', display: 'flex' }}>
          {children}
        </Content>
        <BottomFooter locale={locale} />
        {(false && siteType && siteType.site_type != 2) && <Customer loginStatus="true" />}
      </Layout>
    ),
    inner: (
      <Layout style={{ minHeight: '100%' }}>
        <Header className="header">
          <Headers />
        </Header>
        <Content
          style={{
            background: '#FFFFFF',
            border: '1px solid #DBE6F1',
            display: 'flex',
          }}
        >
          <Layout style={{ background: '#fff', width: "100%" }}>
            <Sider
              width={200}
              style={{
                background: '#fff',
              }}
            >
              <div style={{
                minHeight: '560px',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between'
              }}>
                <Menu
                  mode="inline"
                  selectedKeys={[selectedKey]}
                  defaultOpenKeys={defaultOpenKeys}
                  style={{ height: '100%', width: 'calc(100% - 1px)', marginTop: 0 }}
                  className={sessionStorage.getItem('canSeeRoma') ? "layoutMenus" : "noLayoutMenus"}
                >
                  {subMenu.map((menu, index) => {
                    return RenderMenu(menu, index);
                  })}
                </Menu>
                <div style={{ marginBottom: '30px' }}>
                </div>
              </div>
            </Sider>
            <Content
              style={{
                minHeight: 280,
                margin: '0px',
                overflowX: 'inherit',
                width: 'calc(100% - 200px)',
              }}
              className={'content'}
            >
              {children}
            </Content>
          </Layout>
        </Content>
        <BottomFooter locale={locale} />
        {(false && siteType && siteType.site_type != 2) && <Customer loginStatus="true" />}
      </Layout>
    ),
    default: <Fragment>{children}</Fragment>
  };
  return layouts[_layout] || layouts.default;
};

